import { useAccountList } from "@/pages/consumption/view/billing-details/view/volume-detail/hooks/useAccountList";

export function useAccountOptions() {
  const { data } = useAccountList();

  return (
    data?.map((d) => ({
      label: d.userName,
      value: d.userId,
    })) ?? []
  );
}
